import { render, staticRenderFns } from "./ComponentiScartati.vue?vue&type=template&id=14cf5634&scoped=true&"
import script from "./ComponentiScartati.vue?vue&type=script&lang=js&"
export * from "./ComponentiScartati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cf5634",
  null
  
)

export default component.exports